import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {Router} from "@angular/router";
import {FormGroup} from "@angular/forms";
import {DataService} from "../services/data.service";
import {ToastsManager} from "ng2-toastr";
/**
 * Review
 * Todo:
 * Что это за пустой компонент?
 */
@Component({
  selector: 'app-authorization-component',
  templateUrl: './authorization-component.component.html',
  styleUrls: ['./authorization-component.component.css']
})
export class AuthorizationComponentComponent implements OnInit {
  progress: boolean;
  form: FormGroup;
  model: any = {};
  username: string;
  errorMessage: any;
  public data: any = [];
  checkrobot: boolean;
  ticks: number;

  constructor(public router: Router,public dataService: DataService,
              public toastr: ToastsManager, vRef: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vRef);
    this.checkrobot = false;
    this.progress = false;
  }

  ngOnInit() {
  }





}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/authorization-component/authorization-component.component.ts